import classnames from 'classnames2';
import React from 'react';

import { matchDisplayName } from '../utils';

import { Icon, IIconProps } from '../Icon';

import styles from './styles.module.scss';

const mapPropsToStyles = (props) => ({
  [styles.disabled]: props.disabled,
  [styles.sizeSmall]: props.size === 'small',
  [styles.wrapDisabled]: props.disableWrap
});

export const InputGroupText = (props) => (
  <div className={classnames(styles.inputGroupText, mapPropsToStyles(props))}>{props.children}</div>
);

export interface IInputGroupLabel {
  id?: string;
  ariaLabel?: string;
  htmlFor?: string;
}

export const InputGroupLabel: React.SFC<IInputGroupLabel> = ({ id, ariaLabel, children, htmlFor = '' }) => (
  <label id={id} aria-label={ariaLabel} htmlFor={htmlFor} className={styles.inputGroupText}>
    {children}
  </label>
);

export interface IInputGroupPrefix {
  disabled?: boolean;
  size?: 'default' | 'small';
  dataTest?: string;
}

export const InputGroupPrefix = (props) => (
  <div className={classnames(styles.inputGroupPrefix, mapPropsToStyles(props))} data-test={props.dataTest}>
    {React.Children.map(props.children, (childRef) => {
      if (matchDisplayName(childRef, 'Select')) {
        return React.cloneElement(childRef as any, {
          className: classnames(styles.inputGroupSelect, (childRef as any).props.className)
        });
      } else {
        return childRef;
      }
    })}
  </div>
);

export interface IInputGroupSuffix {
  disabled?: boolean;
  size?: 'default' | 'small';
  dataTest?: string;
}

export const InputGroupSuffix = (props) => (
  <div className={classnames(styles.inputGroupSuffix, mapPropsToStyles(props))} data-test={props.dataTest}>
    {React.Children.map(props.children, (childRef) => {
      if (matchDisplayName(childRef, 'Select')) {
        return React.cloneElement(childRef as any, {
          className: classnames(styles.inputGroupSelect, (childRef as any).props.className)
        });
      } else {
        return childRef;
      }
    })}
  </div>
);

export const InputGroupIcon: React.SFC<IIconProps> = (props) => (
  <div className={styles.inputGroupIcon}>
    <Icon {...props} />
  </div>
);

export interface IInputGroup {
  className?: string;
  dataTest?: string;
  width?: 'min' | 'full';
}

export class InputGroup extends React.Component<IInputGroup> {
  static Prefix = InputGroupPrefix;
  static Suffix = InputGroupSuffix;
  static Label = InputGroupLabel;
  static Text = InputGroupText;
  static Icon = InputGroupIcon;

  render() {
    const containerStyles = classnames(styles.inputGroup, this.props.className, {
      [styles.widthFull]: this.props.width === 'full'
    });

    return (
      <div className={containerStyles} data-test={this.props.dataTest}>
        {React.Children.map(this.props.children, (childRef) => {
          if (matchDisplayName(childRef, 'Input.')) {
            return React.cloneElement(childRef as any, {
              className: classnames(styles.inputGroupInput, (childRef as any).props.className)
            });
          } else if (matchDisplayName(childRef, 'Select')) {
            return React.cloneElement(childRef as any, {
              className: classnames(styles.inputGroupSelect, (childRef as any).props.className)
            });
          } else {
            return childRef;
          }
        })}
      </div>
    );
  }
}
